import { Box, Table, TableBody, TableHead, TableRow, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
} from '../../../common/components';
import { formatFeeNumbers } from '../utils/registerPaymentUtils';

const RegisterPaymentDataTable = ({
  data,
  isLoading,
  handleDeleteCoupon,
  totalCupones,
  totalAmount,
  LoadingComponent,
}) => {
  return (
    <>
      <Box
        sx={{
          justifyContent: 'space-around',
          padding: '15px 30px',
          borderColor: '#ccc',
          borderLeft: '1px solid #ccc',
          borderRight: '1px solid #ccc',
          borderBottom: '1px solid #ccc',
          p: 2,
          display: 'flex',
          width: '100%',
          transition: 'all 0.3s ease',
          borderBottomLeftRadius: '5px',
          borderBottomRightRadius: '5px',
        }}
      >
        <Box sx={{ fontWeight: 'bold', marginRight: 4 }}>Cupones Ingresados: {totalCupones}</Box>
        <Box sx={{ fontWeight: 'bold' }}>Importe Total: $ {totalAmount.toFixed(2)}</Box>
      </Box>

      <GeneralTableBox sx={{ width: '100%' }}>
        <Table
          aria-label="payment table"
          sx={{
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow>
              <HeadTableCell wmd="15%" wxs="20%">
                Contrato
              </HeadTableCell>
              <HeadTableCell wmd="35%" wxs="40%">
                Suscriptor/s
              </HeadTableCell>
              <HeadTableCell wmd="15%" wxs="15%">
                Cuota/s
              </HeadTableCell>
              <HeadTableCell wmd="15%" wxs="15%">
                Mes
              </HeadTableCell>
              <HeadTableCell wmd="10%" wxs="10%">
                Importe
              </HeadTableCell>
              <HeadTableCell wmd="10%" wxs="0%">
                Acciones
              </HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <LoadingComponent />
            ) : data && data.length > 0 ? (
              data.map((row, key) => (
                <TableRow
                  key={key}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  <RowTableCell fontxs="11px" fontmd="14px">
                    {row.contract_number}
                  </RowTableCell>
                  <RowTableCell fontxs="11px" fontmd="14px">
                    {row.subscribers}
                  </RowTableCell>
                  <RowTableCell fontxs="11px" fontmd="14px">
                    {formatFeeNumbers(row)}
                  </RowTableCell>
                  <RowTableCell fontxs="11px" fontmd="14px">
                    {row.month}
                  </RowTableCell>
                  <RowTableCell fontxs="11px" fontmd="14px">
                    ${parseFloat(row.amount).toFixed(2)}
                  </RowTableCell>
                  <RowTableCell>
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteCoupon(row.uuid)}
                      sx={{
                        '&:hover': {
                          transform: 'scale(1.1)',
                          backgroundColor: 'rgba(211, 47, 47, 0.08)',
                        },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </RowTableCell>
                </TableRow>
              ))
            ) : (
              <NoDataSkeleton colSpan={6} message="No hay cupones registrados" />
            )}
          </TableBody>
        </Table>
      </GeneralTableBox>
    </>
  );
};

export default RegisterPaymentDataTable;
